export const getDateFromString = (dateStr) => {
  const [date, month, year] = dateStr.split('/');
  return new Date(Date.UTC(Number(year), Number(month) - 1, Number(date)));
}
